import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import SpRoleHoursTable from "../SpRoleHoursTable";
import axios from "axios";
import moment from "moment";
import ResHoursTRangeForm from "../ResHoursTRangeForm";
import { ResourceDailyHoursAPIs } from "./ResourceDailyHoursAPIs";
import { UserConsumer } from "../../../UserContext";
import Header from "../../../components/Header";
import { AlertPopups } from "../../../components/AlertPopups";
import { Redirect } from "react-router-dom";

const ResourceDailyHours = () => {
	let token,
		employeeId,
		empDepartment,
		empDesignation = null;
	const defaultSorted = [
		{
			dataField: "date",
			order: "desc",
		},
	];
	const [resourceDailyHours, setResourceDailyHours] = useState([]);
	const [employeeList, setEmployeeList] = useState([]);
	const [empID, setEmpId] = useState();
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [pageNum, setPageNum] = useState(1);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(20);
	const [startDateCalender, setStartDateOpenCalender] = useState(false);
	const [endDateCalender, setEndDateOpenCalender] = useState(false);
	const [totalHours, setTotalHours] = useState();
	const [isLoading, setIsLoading] = useState(false);
	const [pagerData, setPagerData] = useState(null);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [flag, setFlag] = useState(false);
	const [showExportExcelBtnLoading, setShowExportExcelBtnLoading] =
		useState(false);

	useEffect(() => {
		setStartDate(moment(new Date()).subtract(30, "days")._d);
		getEmployeeList();
	}, []);
	const startDateHandleChange = (date) => {
		setStartDate(date);
	};
	const endDateHandleChange = (date) => {
		setEndDate(date);
	};
	const startDateOpenCalendar = () => {
		if (startDateCalender) {
			setStartDateOpenCalender(false);
		} else {
			setStartDateOpenCalender(true);
		}
	};

	const endDateOpenCalendar = () => {
		if (endDateCalender) {
			setEndDateOpenCalender(false);
		} else {
			setEndDateOpenCalender(true);
		}
	};
	const getTableData = (e) => {
		e.preventDefault();

		if (empID != null) {
			setIsLoading(true);
			axios
				.get(
					`${
						ResourceDailyHoursAPIs.GetResourceDailyHours
					}?EmpId=${empID}&StartDate=${moment(startDate).format(
						"YYYY MM DD"
					)}&EndDate=${moment(endDate).format(
						"YYYY MM DD"
					)}&SortBy=${"asc"}&PageNumber=${pageNum}&PageSize=${numberOfItemsPerPage}`,
					{ headers: { Authorization: `Bearer ${token}` } }
				)
				.then((res) => {
					setIsLoading(false);
					setFlag(true);
					setResourceDailyHours(res.data["resourceDailyHoursResult"]);
					setTotalHours(res.data.totalHours);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
				});
		} else
			AlertPopups.ErrorAlert.fire({
				text: "Please Select Employee",
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		if (type === "sort" || type === "pagination") {
			if (empID != null) callAPI(type, { page, sortOrder, sortField });
		}
	};
	const callAPI = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${
				ResourceDailyHoursAPIs.GetResourceDailyHours
			}?EmpId=${empID}&StartDate=${moment(startDate).format(
				"YYYY MM DD"
			)}&EndDate=${moment(endDate).format(
				"YYYY MM DD"
			)}&SortBy=${sortField}_${sortOrder}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${
				ResourceDailyHoursAPIs.GetResourceDailyHours
			}?EmpId=${empID}&StartDate=${moment(startDate).format(
				"YYYY MM DD"
			)}&EndDate=${moment(endDate).format("YYYY MM DD")}&SortBy=${
				sortBy.dataField
			}_${
				sortBy.order
			}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					if (res.status === 200) {
						setFlag(true);
						setIsLoading(false);
						setResourceDailyHours(
							res.data["resourceDailyHoursResult"]
						);
						setTotalHours(res.data.totalHours);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setPageNum(page);
					}
				});
		}
	};
	const receiveData = (PageSize) => {
		setIsLoading(true);
		axios
			.get(
				`${
					ResourceDailyHoursAPIs.GetResourceDailyHours
				}?EmpId=${empID}&StartDate=${moment(startDate).format(
					"YYYY MM DD"
				)}&EndDate=${moment(endDate).format(
					"YYYY MM DD"
				)}&SortBy=${"asc"}&PageSize=${PageSize}&PageNumber=1`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then((res) => {
				setFlag(true);
				setIsLoading(false);
				setPageNum(1);
				setNumberOfItemsPerPage(PageSize);
				setResourceDailyHours(res.data["resourceDailyHoursResult"]);
				setTotalHours(res.data.totalHours);
				setPagerData(JSON.parse(res.headers["x-pagination"]));
			});
	};
	const getEmpId = (obj) => {
		setEmpId(obj.value);
	};
	const getEmployeeList = () => {
		if (
			empDepartment === "5" || //Accounts
			empDepartment === "9" || //Admin
			empDesignation?.toString() === "4" || //CM
			employeeId?.toString() === "180" //Abdullah
		) {
			axios
				.get(`${ResourceDailyHoursAPIs.GetEmployeeList}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					empList.unshift({ employeeId: 0, name: "All" });
					setEmployeeList(empList);
				});
		} else {
			axios
				.get(`${ResourceDailyHoursAPIs.GetSupervisorsEmployeesList}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					empList.unshift({ employeeId: 0, name: "All" });
					setEmployeeList(empList);
				});
		}
	};
	const allEmployees = employeeList.map((item) => {
		return { value: item.employeeId, label: item.name };
	});

	const exportToExcel = (e) => {
		e.preventDefault();
		setShowExportExcelBtnLoading(true);

		axios({
			url: `${
				ResourceDailyHoursAPIs.ExportToExcel
			}?EmpId=${empID}&StartDate=${moment(startDate).format(
				"yyyy-MM-DD"
			)}&EndDate=${moment(endDate).format("yyyy-MM-DD")}`,
			method: "GET",
			responseType: "blob",
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "ResourceDailyHours.xlsx");
				document.body.appendChild(link);
				link.click();
				setShowExportExcelBtnLoading(false);
			})
			.catch((err) => {
				setShowExportExcelBtnLoading(false);
				if (err.response.data) {
					AlertPopups.ErrorAlert.fire({
						text: "Please Select Employee",
					});
				}
			});
	};
	const columns = [
		{
			dataField: "employeeName",
			text: "Employee Name",
			sort: true,
		},
		{
			dataField: "taskCategory",
			text: "Task Category",
			sort: true,
		},
		{
			dataField: "taskTitle",
			text: "Task Title",
			sort: true,
		},
		{
			dataField: "hours",
			text: "Hours",
			sort: true,
		},
		{
			dataField: "date",
			text: "Date",
			sort: true,
			formatter: (cell) => {
				return moment(cell).format("DD/MM/YYYY");
			},
		},
		{
			dataField: "day",
			text: "Day",
			sort: false,
		},
	];

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empDesignation = userDetails.designation;
				empDepartment = userDetails.department;
				employeeId = userDetails.id;
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.empRole.includes("3") ? (
					<Container fluid className="container-fluid pl-3 pr-3">
						<Header
							title="Resource Daily Hours"
							headerBorder={true}
						/>
						<ResHoursTRangeForm
							data={resourceDailyHours}
							allEmployees={allEmployees}
							exportToExcel={exportToExcel}
							clicked={getTableData}
							getEmpId={getEmpId}
							startDateOpenCalendar={startDateOpenCalendar}
							endDateOpenCalendar={endDateOpenCalendar}
							startDateCalender={startDateCalender}
							endDateCalender={endDateCalender}
							startDateHandleChange={startDateHandleChange}
							endDateHandleChange={endDateHandleChange}
							startDate={startDate}
							endDate={endDate}
							showBtnLoading={showExportExcelBtnLoading}
						/>

						<SpRoleHoursTable
							handleTableChange={handleTableChange}
							tabledata={resourceDailyHours}
							isLoading={isLoading}
							pagerData={pagerData}
							columns={columns}
							defaultSorted={defaultSorted}
							totalHours={totalHours}
							numberOfItemsPerPage={numberOfItemsPerPage}
							pageNum={pageNum}
							receiveData={(pageSize) => receiveData(pageSize)}
							flag={flag}
						/>
					</Container>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
};

export default ResourceDailyHours;
